import { useQuery } from '@tanstack/react-query';

import { fetchStatsFetcher } from '../../fetchers/video-player-fetcher';

type Props = {
  data: any;
  isLoading: boolean;
  refetch: () => void;
  isFetched: boolean;
};

const useFetchStats = ({ typeId, userId }: { typeId: string; userId: string }): Props => {
  const { data, isLoading, refetch, isFetched } = useQuery(
    [
      'fetch-stats',
      {
        typeId,
        userId,
      },
    ],
    fetchStatsFetcher,
    {
      enabled: !!typeId && !!userId,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 60 * 10 * 1000,
    },
  );

  return {
    isLoading,
    data: data?.data || [],
    refetch,
    isFetched,
  };
};

export default useFetchStats;
